import { render, staticRenderFns } from "./CustomerFields.vue?vue&type=template&id=1c45b610&scoped=true&lang=pug&"
import script from "./CustomerFields.vue?vue&type=script&lang=js&"
export * from "./CustomerFields.vue?vue&type=script&lang=js&"
import style0 from "./CustomerFields.vue?vue&type=style&index=0&id=1c45b610&scoped=true&lang=stylus&"
import style1 from "./CustomerFields.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c45b610",
  null
  
)

export default component.exports